import { useEffect, useState } from 'react'

import { RhyBusInputCheck,RhyBusInputText } from '@rhybus/form-controls'
import { RhyBusButton } from '@rhybus/button'
import { ListNames } from '../../../config/configuration'
import { rhybusRListsHttp } from '../../../api/rhybus-list-http'
import PageOverlay from '../../../utils/controls/pageoverLay/pageoverLay'
interface FormatText {
  id: number;
  text?: string;
  text1?: string;
  text2?: string;
  useState?: any;
  mainId?: any
  ID?: any
  IsEnable?: any
  width?: any
}
interface Props {
  Item?: any
  formats?: any
  getData?: any
  ParamMode?: any
}
export function getCurrentUTCDate() {
  return new Date().toISOString()
}
export const ConfigurationFormat = (Props: Props) => {
  const [showDiv, setShowDiv] = useState(false)
  const [texts, setTexts] = useState<FormatText[]>([])
  const [isEnableFormat, setIsEnableFormat] = useState(true)
  const [formatName, setFormatName] = useState('')
  const [formatExample, setFormatExample] = useState('')
  const [formatRegex, setFormatRegex] = useState('')
  const [_showInvalidErr, setShowInvalidErr] = useState(false)
  const [_showLoaderadd, setShowLoaderadd] = useState(false)
  const [showErrorFormat, setShowErrorFormat] = useState(false)
  const [showErrorRegex, setShowErrorRegex] = useState(false)
  const [catError, _setCatError] = useState(false)
  const [isDisable, setIsDisable] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const objectPreparation: any = []
    if (Props?.formats) {
      Props?.formats.forEach((element: any, _index: any) => {
        if (element?.PID === Props?.Item) {
          objectPreparation.push({
            id: element?.PID, text: element?.Format, text1: element?.FormatExample, text2: element?.FormatRegExp, mainId: element?.ID, ID: element?.ID, IsEnable: element?.IsEnable
          })
        }
      })
    }
    setTexts(objectPreparation)
  }, [Props])
  const [editingId, setEditingId] = useState<number | null>(null)
  const handleTextChange = (id: number, value: string, newText: string) => {
    setTexts((prevTexts) =>
      prevTexts.map((text) => (text.mainId === id ? { ...text, [value]: newText } : text))
    )
  }
  const handleEdit = (id: number) => {
    setEditingId(id)

  }

  const updateFormat = async (value: any, _eKey: any, mainId: any, IsEnableUpdate: any) => {
    const updatedArray: any = []
    texts.forEach((item: any) => {
      if (item.mainId === mainId) {
        updatedArray.push(item)
      }
    })
    const ObjectArray: any = {}
    setShowInvalidErr(false)
    let validRegex = true
    try {
      new RegExp('(' + updatedArray[0]?.text2 + ')')
    } catch {
      validRegex = false
    }
    if (validRegex && updatedArray[0]?.text?.trim() !== '' && updatedArray[0]?.text2?.trim() !== '') {
      if (IsEnableUpdate) {
        ObjectArray.ID = mainId
        ObjectArray.IsEnable = value
        ObjectArray.ItemModified = getCurrentUTCDate()
        ObjectArray.ItemModifiedById = (window as any)._spPageContextInfo?.userId ?? 0
        const list = await rhybusRListsHttp().getList(ListNames?.PII_FORMATS)
        await list.addOrUpdateItem({eKey: String(mainId), ...ObjectArray} as any)
        await Props?.getData?.getData()
      } else {
        setLoading(true)
        ObjectArray.ID = mainId
        ObjectArray.Format = updatedArray[0]?.text
        ObjectArray.FormatExample = updatedArray[0]?.text1
        ObjectArray.FormatRegExp = updatedArray[0]?.text2
        ObjectArray.ItemModified = getCurrentUTCDate()
        ObjectArray.ItemModifiedById = (window as any)._spPageContextInfo?.userId ?? 0
        const list = await rhybusRListsHttp().getList(ListNames?.PII_FORMATS)
        await list.addOrUpdateItem({eKey: String(mainId), ...ObjectArray} as any)
        await Props?.getData?.getData()
        setEditingId(null)
        setLoading(false)
      }
    } else {
      if (!validRegex) {
        setShowInvalidErr(true)
      }
      if (formatName?.trim() === '') {
        setShowErrorFormat(true)
      } else { setShowErrorFormat(false) }
      if (formatRegex?.trim() === '') {
        setShowErrorRegex(true)
      } else { setShowErrorRegex(false) }
    }
  }
  const handleCancel = () => {
    setEditingId(null)
  }
  const AddNewFormate = async (id: number) => {
    setShowInvalidErr(false)
    let validRegex = true
    try {
      new RegExp('(' + formatRegex + ')')
    } catch {
      validRegex = false
    }
    if (formatName?.trim() !== '' && formatRegex?.trim() !== '' && validRegex) {
      setLoading(true)
      setIsDisable(true)
      setShowLoaderadd(true)
      const ObjectArray: any = {
        Format: formatName,
        FormatExample: formatExample,
        FormatRegExp: formatRegex,
        PID: id,
        IsEnable: isEnableFormat,
        ItemModifiedById: (window as any)._spPageContextInfo?.userId ?? 0,
        ItemModified: getCurrentUTCDate(),
        ItemCreated: getCurrentUTCDate(),
        ItemCreatedById: (window as any)._spPageContextInfo?.userId ?? 0
      }
      const list = await rhybusRListsHttp().getList(ListNames?.PII_FORMATS)
      await list.addOrUpdateItem(ObjectArray as any)
      setShowDiv(false)
      setIsDisable(false)
      setLoading(false)
      await Props?.getData?.getData()
    } else {
      setIsDisable(false)
      setLoading(false)
      if (!validRegex) {
        setShowInvalidErr(true)
      }
      if (formatName?.trim() === '') {
        setShowErrorFormat(true)
      } else { setShowErrorFormat(false) }
      if (formatRegex?.trim() === '') {
        setShowErrorRegex(true)
      } else { setShowErrorRegex(false) }
    }
  }
  return (
    <>
      {loading && <PageOverlay />}
      <div className='w-100 overflow-auto'>
        <table className="table-borderless w-100 sticky-top first-column last-column" >
          <thead>
            <tr>
              <th style={{ width: 40 }} className='py-1 font-0'>id</th>
              <th className='py-1' tabIndex={0} aria-label="Format">Format</th>
              <th className='py-1' tabIndex={0} aria-label="Example">Example</th>
              <th className='py-1' tabIndex={0} aria-label="Regular Expression">Regular Expression</th>
              <th className='py-1'>
                <RhyBusButton
                  label="New Format"
                  aria-label="New Format"
                  leftIcon="icon-rb-add me-1 font-11"
                  onClick={() => {
                    setShowDiv(!showDiv)
                    setFormatName('')
                    setFormatExample('')
                    setFormatRegex('')
                    setShowErrorFormat(false)
                    setShowErrorRegex(false)
                  }}
                /></th>
            </tr>
          </thead>
          <tbody>
            {showDiv &&
              <tr>
                <th className='v-align-top'>

                  <RhyBusInputCheck
                    id="inputcheck"
                    name="Input Check"
                    type="checkbox"
                    label="check"
                    checked={isEnableFormat}
                    onChange={(_e: any) => { setIsEnableFormat(!isEnableFormat) }}

                  />
                </th>
                <th className='v-align-top'>
                  <div className='d-flex'>
                    <RhyBusInputText
                      label="Format"
                      onChange={(e: any) => setFormatName(e.target.value)}
                      id='newformat'
                      name='newformat'
                      placeholder='Enter Format'
                      size='sm'
                      value={formatName}
                      error={showErrorFormat}
                      maxLength={256}
                      isMandatory
                      iconLeft
                      formlayout="horizontal"
                    />
                    <span className='mandatory ms-1'>*</span>
                  </div>
                </th>
                <td className='v-align-top'>
                  <RhyBusInputText
                    label="Format"
                    onChange={(e: any) => setFormatName(e.target.value)}
                    id='newformat'
                    name='newformat'
                    placeholder='Enter Format'
                    size='sm'
                    value={formatName}
                    error={showErrorFormat}
                    maxLength={256}
                    isMandatory
                    iconLeft
                    formlayout="horizontal"
                  />
                </td>
                <td className='v-align-top'><div className='d-flex'>
                  <RhyBusInputText
                    label="Regular Expression"
                    onChange={(e: any) => setFormatRegex(e.target.value)}
                    id='newregularexpression'
                    name='newregularexpression'
                    placeholder='Enter Regular Expression'
                    size='sm'
                    value={formatRegex}
                    error={showErrorRegex}
                    maxLength={256}
                    isMandatory
                    iconLeft
                    formlayout="horizontal"
                  />
                </div>
                </td>
                <th className='v-align-top'>
                  <div className='d-flex gap-1'>
                    <RhyBusButton
                      disabled={isDisable}
                      label="Save"
                      aria-label="Save"
                      leftIcon="icon-rb-checked font-11"
                      onClick={() => AddNewFormate(Props?.Item)} />

                    <RhyBusButton
                      label="Cancel"
                      aria-label="Cancel"
                      leftIcon="icon-rb-close font-11 "
                      onClick={() => setShowDiv(false)} />
                  </div>
                </th>
              </tr>}
            {texts.map((text, _index) => (
              <tr key={text.id}>
                {editingId === text.mainId
                  ? (
                    <>
                      <th className='checkbox'>

                        <RhyBusInputCheck
                          id={text.id.toString()}
                          name="Input Check"
                          type="checkbox"
                          label={text.text??''}
                          checked={text?.IsEnable === true ? true : false}
                          onChange={(e: any) => updateFormat(e.target.checked, text.ID, text?.mainId, true)}

                        />
                      </th>
                      <th className="col-sm-3">
                        <input className='form-xs'
                          type="text"
                          value={text.text}
                          onChange={(e) => handleTextChange(text.mainId, 'text', e.target.value)}
                        />
                        {catError && <span className="pii-errormsg">
                          Please enter Category Name
                        </span>}
                      </th>
                      <td className="col-sm-3">
                        <input className='form-xs'
                          type="text1"
                          value={text.text1}
                          onChange={(e) => handleTextChange(text.mainId, 'text1', e.target.value)}
                        />
                      </td>
                      <td className="col-sm">
                        <input className='form-xs'
                          type="text2"
                          value={text.text2}
                          onChange={(e) => handleTextChange(text.mainId, 'text2', e.target.value)}
                        />
                      </td>
                      <th className="col-sm-2 col-md-3">
                        <div className='d-flex gap-1'>
                          <RhyBusButton onClick={() => updateFormat('', text.id, text.mainId, false)}
                            label="Save"
                            aria-label="Save"
                            leftIcon="icon-rb-checked font-11"
                          />
                          <RhyBusButton onClick={handleCancel}
                            label="Cancel"
                            aria-label="Cancel"
                            leftIcon="icon-rb-close font-11 "
                          />
                        </div>
                      </th>
                    </>
                  )
                  : (
                    <>
                      <th className='checkbox'>
                        
                        <RhyBusInputCheck
                          id={text.id.toString()}
                          name="Input Check"
                          type="checkbox"
                          label={text?.text ?? ''}
                          checked={text?.IsEnable === true ? true : false}
                          onChange={(e: any) => updateFormat(e.target.checked, text.ID, text?.mainId, true)}

                        />
                      </th>
                      <th tabIndex={0} aria-label={text.text} className="col-sm-3">
                        {text.text}
                      </th>
                      <td tabIndex={0} aria-label={text.text1} className="col-sm-3">
                        {text.text1}
                      </td>
                      <td tabIndex={0} aria-label={text.text2} className="col-sm">
                        {text.text2}
                      </td>
                      <th className="col-sm-2 col-md-3">
                        <div className={Props?.ParamMode === 'P' ? 'ms-auto d-flex gap-1 d-none' : 'ms-auto d-flex gap-1'}>
                          <RhyBusButton onClick={() => handleEdit(text.mainId)}
                            label="Edit"
                            aria-label="Edit"
                            leftIcon="icon-rb-pencil font-11"
                          />
                        </div>
                      </th>
                    </>
                  )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}
